var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14",
      "height": "14",
      "viewBox": "0 0 14 14",
      "fill": "none"
    }
  }, [_c('ellipse', {
    attrs: {
      "cx": "7",
      "cy": "7",
      "rx": "7",
      "ry": "7",
      "transform": "matrix(-4.37114e-08 -1 -1 4.37114e-08 14 14)",
      "fill": "#ED6400"
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }